import AboutCreditScore from 'features/creditScore/aboutCreditScore/AboutCreditScore';
import React from 'react';

export default function AboutCreditScorePage() {
  return <AboutCreditScore />;
}
